package org.example.project.screens_cus_mobile.we

import androidx.compose.runtime.Composable
import org.example.project.dashboard.DashboardTheme
import org.example.project.settings.LumaticaCheckbox
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun CUSMobileWEAbschlussScreen(
    leergut: String,
    palettenGetauscht: Boolean,
    onPalettenGetauschtChange: (Boolean) -> Unit,
    onLeergutChange: (String) -> Unit
) {
    CUSMobileWEPalettenGetauschtField(
        checked = palettenGetauscht,
        value = leergut,
        onCheckedChange = onPalettenGetauschtChange,
        onValueChange = onLeergutChange
    )
}

@Composable
fun CUSMobileWEBestaetigungScreen(
    sollPaletten: Int,
    unbeschaedigt: String,
    onUnbeschaedigtChange: (String) -> Unit,
    fehlmenge: String,
    onFehlmengeChange: (String) -> Unit,
    bruch: String,
    onBruchChange: (String) -> Unit,
    ueberzaehlig: String,
    onUeberzaehligChange: (String) -> Unit
) {
    Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900"); lineHeight("1.3") } }) {
        Text("Bitte bestätige den vollständigen Wareneingang von $sollPaletten Paletten")
    }
    Div({ style { width(100.percent); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(14.px) } }) {
        CUSMobileWELabeledNumberField("Paletten unbeschädigt", unbeschaedigt, onUnbeschaedigtChange)
        CUSMobileWELabeledNumberField("Paletten Fehlmenge", fehlmenge, onFehlmengeChange)
        CUSMobileWELabeledNumberField("Paletten Bruch", bruch, onBruchChange)
        CUSMobileWELabeledNumberField("Paletten Überzählig", ueberzaehlig, onUeberzaehligChange)
    }
}

@Composable
private fun CUSMobileWELabeledNumberField(label: String, value: String, onValueChange: (String) -> Unit) {
    Div({
        style {
            width(100.percent)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.FlexStart)
            gap(8.px)
        }
    }) {
        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(15.px); fontWeight("800"); lineHeight("1.2") } }) {
            Text(label)
        }
        CUSMobileWENumberField(value, "Anzahl", onValueChange)
    }
}

@Composable
private fun CUSMobileWEPalettenGetauschtField(
    checked: Boolean,
    value: String,
    onCheckedChange: (Boolean) -> Unit,
    onValueChange: (String) -> Unit
) {
    Div({ style { width(100.percent); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(14.px) } }) {
        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900"); lineHeight("1.3"); textAlign("center") } }) {
            Text("Hast du Paletten getauscht?")
        }
        Div({
            style {
                width(100.percent)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.Center)
                gap(10.px)
            }
        }) {
            CUSMobileWECheckboxChoice("Ja", checked, onClick = { onCheckedChange(true) })
            CUSMobileWECheckboxChoice("Nein", !checked, onClick = { onCheckedChange(false) })
        }
        if (checked) {
            CUSMobileWENumberField(value, "Anzahl", onValueChange)
        }
    }
}

@Composable
private fun CUSMobileWECheckboxChoice(label: String, checked: Boolean, onClick: () -> Unit) {
    Div({
        style {
            width(220.px)
            maxWidth(100.percent)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(12.px)
        }
    }) {
        LumaticaCheckbox(checked = checked, onChange = { onClick() }, fontSizePx = 28)
        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(16.px); fontWeight("800"); lineHeight("1.2") } }) {
            Text(label)
        }
    }
}

@Composable
private fun CUSMobileWENumberField(value: String, placeholder: String, onValueChange: (String) -> Unit) {
    Input(InputType.Number) {
        value(value)
        attr("placeholder", placeholder)
        style {
            height(56.px)
            width(100.percent)
            padding(0.px, 14.px)
            color(DashboardTheme.TEXT_LIGHT)
            backgroundColor(Color("rgba(255,255,255,0.04)"))
            property("border", "1px solid rgba(255,255,255,0.14)")
            borderRadius(8.px)
            property("box-sizing", "border-box")
            fontSize(22.px)
            fontWeight("900")
            textAlign("center")
        }
        onInput { onValueChange(it.value?.toString().orEmpty().filter(Char::isDigit)) }
    }
}

